import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { Search as SearchIcon } from "lucide-react";

export default function Search() {
  const { search } = useLocation();
  const q = new URLSearchParams(search).get("q") || "";
  const [items, setItems] = useState([]);
  const [cats, setCats] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get("/categories").then((r) => setCats(r.data));
    setLoading(true);
    api.get("/products", { params: q ? { search: q, limit: 48 } : { limit: 48 } })
      .then((r) => setItems(r.data.items)).finally(() => setLoading(false));
  }, [q]);

  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <h1 className="font-serif text-3xl text-[#4A3B40]">{q ? `Busca por "${q}"` : "Todos os produtos"}</h1>
      <p className="text-[#8C7A80] text-sm mt-1 mb-6">{items.length} produtos encontrados</p>

      {!q && (
        <div className="mb-8">
          <h2 className="font-serif text-xl text-[#4A3B40] mb-3">Categorias</h2>
          <div className="flex flex-wrap gap-2">
            {cats.map((c) => (
              <Link key={c.id} to={`/categoria/${c.slug}`} className="bg-white border border-[#F9E1E8] rounded-full px-4 py-2 text-sm hover:bg-[#F9E1E8] hover:text-[#C9708B] transition-colors" data-testid={`search-cat-${c.slug}`}>
                {c.name}
              </Link>
            ))}
          </div>
        </div>
      )}

      {loading ? (
        <div className="text-center py-20 text-[#8C7A80]">Buscando...</div>
      ) : items.length === 0 ? (
        <div className="text-center py-20"><SearchIcon className="w-12 h-12 text-[#E8A0B4] mx-auto mb-3" /><p className="text-[#8C7A80]">Nenhum produto encontrado.</p></div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {items.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
